module.exports = __webpack_public_path__ + "static/media/canadian-owned-mb-en.cfc56a65.jpg";